import { OrgAdminConstants } from '../../../_constants';

const initialState = { editOrgTeamLoading: true, data: '', error: false };

export function editOrgTeamReducer(state = initialState, action) {
    
    switch (action.type) {
        case OrgAdminConstants.REQUEST_EDIT_ORG_TEAM:
            return {
                editOrgTeamLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_EDIT_ORG_TEAM:
            return {
                editOrgTeamLoading: false,
                data: action.getOrgTeam,
                error: false
            };
        case OrgAdminConstants.EDIT_ORG_TEAM_ERROR:
            return {
                editOrgTeamLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/OrgTeam/editOrgTeam.reducer.js